import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { TextField, MenuItem  } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    }
}));

function TargetPerson(props) {

    const igonFlag = useSelector(state => state.igon.igonFlag);
    const heiress = useSelector(state => state.heiress.heiress);

    const classes = useStyles();

    if(igonFlag){
        console.log(props.targetPersonValue);
        return(
            <TextField
                id={props.targetPersonId}
                select
                name={props.targetPersonName}
                label="この財産の取得対象者"
                style={{ margin: 8 }}
                className={classes.required}
                placeholder="取得対象者をご入力ください。"
                helperText={props.targetPersonHelperText}
                fullWidth
                margin="normal"
                inputProps={{
                    required: true,
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={props.handleTargetPerson}
                error={props.targetPersonValidate}
                value={props.targetPersonValue}
            >
                {
                    heiress.map((row, index) => {
                        return (
                            <MenuItem key={index} value={index}>
                                {row.name}
                            </MenuItem>
                        );
                    })
                }
            </TextField>
        );
    }else{
        return(<></>);
    }
}

export default TargetPerson;
